import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CreateAccount from '../auth/createAccount'
import LoginAccount from '../auth/loginAccount'
import { CDN_BASE_URL } from '../../constants'
import ForgotPassword from '../auth/forgotPassword'
import Logo from '../../assets/Logo.svg'
import { useLocation } from 'react-router-dom'
import { useGBValue } from '../../hooks/useGBValue'

const AuthModal = ({ isOpen, onClose, selectedStyle }) => {
  const [authView, setAuthView] = useState('signup')

  const location = useLocation()
  const ab_testing = useGBValue()
  const isMagicLink = ab_testing['createsexfriends-gray-magicLink'] === 'ON'

  const isHalloween = location.pathname.includes('/halloween')

  const getAuthVideoAndPoster = () => {
    const videoMap = {
      Realistic: [
        {
          video: `${CDN_BASE_URL}/Realistic/auth_realistic.mp4`,
          poster: `${CDN_BASE_URL}/Realistic/first_frame_realistic.jpg`,
        },
        {
          video: `${CDN_BASE_URL}/Realistic/auth_realistic_2.mp4`,
          poster: `${CDN_BASE_URL}/Realistic/first_frame_realistic_2.jpg`,
        },
      ],
      Anime: [
        {
          video: `${CDN_BASE_URL}/Anime/auth_anime.mp4`,
          poster: `${CDN_BASE_URL}/Anime/first_frame_anime.jpg`,
        },
        {
          video: `${CDN_BASE_URL}/Anime/auth_anime_2.mp4`,
          poster: `${CDN_BASE_URL}/Anime/first_frame_anime_2.jpg`,
        },
      ],
    }

    const style = selectedStyle || 'Realistic'
    const videos = videoMap[style] || videoMap.Realistic

    return videos[Math.floor(Math.random() * videos.length)]
  }

  const handleClose = () => {
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className={`auth-modal-overlay${isMagicLink && authView === 'signup' ? ' magic-link' : ''}`}>
      <div className='video-bg'>
        <video
          src={getAuthVideoAndPoster().video}
          poster={getAuthVideoAndPoster().poster}
          autoPlay
          muted
          loop
          playsInline
          alt='Authentication'
          className='auth-image'
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
      <div className='logo'>
        <img src={Logo} alt='' />
      </div>
      <div className={`auth-modal ${isHalloween && 'auth-modal-halloween'}`}>
        <button className='auth-modal-close' onClick={handleClose}>
          ✕
        </button>

        <div className='auth-modal-content'>
          {/* Left Side - Auth Form */}
          <div className='auth-form-container'>
            {authView === 'login' && <LoginAccount onSwitchToSignup={() => setAuthView('signup')} onSwitchToForgot={() => setAuthView('forgot')} />}
            {authView === 'signup' && <CreateAccount onContinue={() => setAuthView('login')} />}
            {authView === 'forgot' && <ForgotPassword onBackToLogin={() => setAuthView('login')} />}
          </div>

          {/* Right Side - Image */}
          <div className='auth-image-container'>
            <video
              src={getAuthVideoAndPoster().video}
              poster={getAuthVideoAndPoster().poster}
              autoPlay
              muted
              loop
              playsInline
              alt='Authentication'
              className='auth-image'
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

AuthModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedStyle: PropTypes.string,
}

export default AuthModal
